import * as PropertyBucket from '../../Properties/Properties';
import * as httpService from '../../Components/HttpService/HttpService';

export function getTypesDataRequested() {
    return {
        type: 'GET_TYPES_DATA_REQUESTED'
    };
}

export function getTypesDataDone(data) {
    return {
        type: 'GET_TYPES_DATA_DONE',
        payload: data
    };
}

export function getTypesDataFailed(error) {
    return {
        type: 'GET_TYPES_DATA_FAILED',
        payload: error
    };
}

export function getTypesData() {
    let url = PropertyBucket.getTypes();
    return dispatch => {
        dispatch(getTypesDataRequested());
        let response = httpService.getService(url, "GET");
            response.then(data => {
                dispatch(getTypesDataDone(data));
            })
            .catch(error => {
                dispatch(getTypesDataFailed(error));
            })
    }
}

export const GET_TYPES_DATA_REQUESTED = 'GET_TYPES_DATA_REQUESTED';
export const GET_TYPES_DATA_DONE = 'GET_TYPES_DATA_DONE';
export const GET_TYPES_DATA_FAILED = 'GET_TYPES_DATA_FAILED';